import React, { useState } from 'react';
import { useContract } from '../../context/ContractContext';
import { states } from '../../data/propertyTypes';

const PartiesForm = () => {
  const { updateContractDataImmediate } = useContract();
  
  const [formData, setFormData] = useState({
    ownerName: '',
    ownerCpf: '',
    ownerEmail: '',
    ownerPhone: '',
    ownerAddress: '',
    ownerCity: '',
    ownerState: '',
    
    tenantName: '',
    tenantCpf: '',
    tenantEmail: '',
    tenantPhone: '',
    tenantAddress: '',
    tenantCity: '',
    tenantState: ''
  });

  const handleChange = (fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
    
    // Salvar no contexto automaticamente a cada mudança
    const partiesData = {
      owner: {
        type: 'pf',
        name: fieldName === 'ownerName' ? value : formData.ownerName,
        cpf: fieldName === 'ownerCpf' ? value : formData.ownerCpf,
        email: fieldName === 'ownerEmail' ? value : formData.ownerEmail,
        phone: fieldName === 'ownerPhone' ? value : formData.ownerPhone,
        address: fieldName === 'ownerAddress' ? value : formData.ownerAddress,
        city: fieldName === 'ownerCity' ? value : formData.ownerCity,
        state: fieldName === 'ownerState' ? value : formData.ownerState
      },
      tenant: {
        type: 'pf',
        name: fieldName === 'tenantName' ? value : formData.tenantName,
        cpf: fieldName === 'tenantCpf' ? value : formData.tenantCpf,
        email: fieldName === 'tenantEmail' ? value : formData.tenantEmail,
        phone: fieldName === 'tenantPhone' ? value : formData.tenantPhone,
        address: fieldName === 'tenantAddress' ? value : formData.tenantAddress,
        city: fieldName === 'tenantCity' ? value : formData.tenantCity,
        state: fieldName === 'tenantState' ? value : formData.tenantState
      }
    };

    updateContractDataImmediate('parties', partiesData);
  };

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-xl font-semibold text-gray-900 mb-6">
          Dados das Partes
        </h2>
        
        {/* Locador/Proprietário */}
        <div className="mb-12">
          <h3 className="text-lg font-semibold text-gray-900 mb-6 pb-2 border-b">
            Dados do Locador/Proprietário
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nome Completo *
              </label>
              <input
                type="text"
                value={formData.ownerName}
                onChange={(e) => handleChange('ownerName', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                CPF *
              </label>
              <input
                type="text"
                value={formData.ownerCpf}
                onChange={(e) => handleChange('ownerCpf', e.target.value)}
                placeholder="000.000.000-00"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                E-mail
              </label>
              <input
                type="email"
                value={formData.ownerEmail}
                onChange={(e) => handleChange('ownerEmail', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Telefone
              </label>
              <input
                type="text"
                value={formData.ownerPhone}
                onChange={(e) => handleChange('ownerPhone', e.target.value)}
                placeholder="(00) 00000-0000"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Endereço
              </label>
              <input
                type="text"
                value={formData.ownerAddress}
                onChange={(e) => handleChange('ownerAddress', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Cidade
              </label>
              <input
                type="text"
                value={formData.ownerCity}
                onChange={(e) => handleChange('ownerCity', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Estado
              </label>
              <select
                value={formData.ownerState}
                onChange={(e) => handleChange('ownerState', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Selecione...</option>
                {states.map((state) => (
                  <option key={state.value} value={state.value}>
                    {state.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Locatário */}
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-6 pb-2 border-b">
            Dados do Locatário
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nome Completo *
              </label>
              <input
                type="text"
                value={formData.tenantName}
                onChange={(e) => handleChange('tenantName', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                CPF *
              </label>
              <input
                type="text"
                value={formData.tenantCpf}
                onChange={(e) => handleChange('tenantCpf', e.target.value)}
                placeholder="000.000.000-00"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                E-mail
              </label>
              <input
                type="email"
                value={formData.tenantEmail}
                onChange={(e) => handleChange('tenantEmail', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Telefone
              </label>
              <input
                type="text"
                value={formData.tenantPhone}
                onChange={(e) => handleChange('tenantPhone', e.target.value)}
                placeholder="(00) 00000-0000"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Endereço
              </label>
              <input
                type="text"
                value={formData.tenantAddress}
                onChange={(e) => handleChange('tenantAddress', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Cidade
              </label>
              <input
                type="text"
                value={formData.tenantCity}
                onChange={(e) => handleChange('tenantCity', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Estado
              </label>
              <select
                value={formData.tenantState}
                onChange={(e) => handleChange('tenantState', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Selecione...</option>
                {states.map((state) => (
                  <option key={state.value} value={state.value}>
                    {state.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartiesForm;